import { render, staticRenderFns } from "./UseOfSoldGoodsMainSection.vue?vue&type=template&id=e3fd630e"
import script from "./UseOfSoldGoodsMainSection.vue?vue&type=script&lang=js"
export * from "./UseOfSoldGoodsMainSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports